<ng-container>
	<flx-tabs [tabs]="tabs" [currentStep$]="currentTab$" [externalPages]="true" (outputEventStream)="handleTab($event)">
		<ng-container *ngIf="(jobSummary$ | async) && (currentTab$ | async) === 'overview'"> </ng-container>
		<ng-container></ng-container>
	</flx-tabs>
</ng-container>
